module.exports = __webpack_public_path__ + "assets/img/1.19a9edff.png";